// extracted by mini-css-extract-plugin
export default {"container":"AdminInfoBox_container__7Zz3C","inputInfo":"AdminInfoBox_inputInfo__IzTzt"};